import React from "react";
import { getValue } from "../../utils/externalFunc";

export default function FormSingleSelect(props) {

    let storeValue = getValue(props.store, props.formFieldDetails.object_path)

    // Check if select values use string IDs (like color names) or numeric IDs
    const hasStringValues = props.formFieldDetails.select_values?.some(item => typeof item.id === 'string');

    const handleChange = (e) => {
        // Only convert to Number if the select values are numeric
        const value = hasStringValues ? e.target.value : Number(e.target.value);
        props.updateFormValues(value, props.formFieldDetails.object_path);
    };

    return  <>
            <label htmlFor={props.keyName} className={`form-label w-100 ${props.keyName}`}>{props.item.IsRequired ? "*" : ""}{props.item.Title}
                <div className="input-group input-group-sm mb-3">
                    <select
                        className={`form-select ${(props.formErrors[props.keyName] || props.formErrors[props.keyName] === "") && !props.disabled ? "is-invalid" : ""}`}
                        value={storeValue}
                        onChange={handleChange}
                        id={props.keyName}
                        required={props.item.IsRequired}
                        aria-label={props.item.Title}
                        disabled={props.disabled}
                    >
                        <option value="">בחרו מהרשימה</option>
                        {
                        props.formFieldDetails.select_values ? props.formFieldDetails.select_values.map((subItem) => {
                                return <option key={subItem.id} value={subItem.id}>{subItem.title}</option>
                            }) : null
                        }
                    </select>
                    <div className="invalid-feedback">{props.errorsObjReady[props.keyName] || `יש למלא ${props.item.Title}`}</div>
                </div>
            </label>
            </>
}